import React, { useContext, useReducer, useState } from 'react'

const initialState = {
  step: 1,
  checkPYME: false,
}
const reducer = (state, action) => {
  switch (action.type) {
    case 'INIT_STEP':
      return { ...state, step: 1 }
    case 'NEXT_STEP':
      if (state.step === 6) {
        return
      } else {
        return { ...state, step: state.step + 1 }
      }
    case 'PREV_STEP':
      if (state.step === 1) {
        return
      } else {
        return { ...state, step: state.step - 1 }
      }
    case 'SET_STATE':
      return { ...state, step: action.payload }
    case 'SET_CHECKPYME':
      return { ...state, checkPYME: action.payload }
    default:
      return state
  }
}

const AsistenciaContext = React.createContext()

export const AsistenciaContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [enableSec3, setEnableSec3] = useState(false)
  React.useEffect(() => {
    dispatch('INIT_STEP')
    setEnableSec3(false)
  }, [])
  return (
    <AsistenciaContext.Provider
      value={[state, dispatch, enableSec3, setEnableSec3]}
    >
      {children}
    </AsistenciaContext.Provider>
  )
}

export const useAsistencia = () => {
  const context = useContext(AsistenciaContext)
  if (context === undefined) {
    throw new Error('useAsistencia can only be used inside FormProvider')
  }
  return context
}
